<template>
  <section
    class="page-container"
    :class="{
      'sub': isReferralRequest
    }">
    <h1>Create {{user_type==1?'Customer Account':'Referrer'}}</h1>
    <div v-if="!customerId">
      <div class="btn-top-container">
        <v-button
          size="mini"
          @click="handlerBack">Back</v-button>
        <v-button
          type="primary"
          size="mini"
          @click="handlerNext">Next</v-button>
      </div>
      <!-- <el-form
        ref="form"
        label-position="top"> -->
      <div class="form-card">
        <div class="form-left">
          <account-form
            ref="base-info"
            :formDataLock="formDataLock"
            :form="formData"
            @handlerChange="handlerChange"
            @getFormData="getSubFormData" />
        </div>
        <div class="form-right">
          <!--          :notValid="true"-->
          <address-form
            ref="address-info"
            :formDataLock="formDataLock"
            :form="formData"
            :identity="identity"
            :form-type="0"
            not-valid
            :is-fina="isFina"
            @getFormData="getSubFormData" />
        </div>
      </div>
      <!-- </el-form> -->
    </div>
    <div v-else>
      <div class="done-container">
        <h2>Account Created</h2>
        <p>The account has been created.</p>
        <v-button
          size="mini"
          type="primary"
          @click="handlerViewAccount">View Account</v-button>
        <!--        <p class="send-title">Please click the link to create your account password</p>-->
        <p class="send-title">Send Create Password Link</p>
        <div v-if="!existEmail">
          <v-button
            v-if="!isSend"
            type="primary"
            plain
            @click="handlerSMS">Send</v-button>
          <p
            v-else
            class="send-tip">Link has been sent to the selected contact methods.</p>
        </div>
        <div
          v-else
          class="exist-eamil">
          <p>This email is already registered with another account, and share the same login credentials.</p>
          <p>To reset the password of both accounts, edit one of the accounts’ profile and send the reset password link from there.</p>
        </div>
      </div>
    </div>
    <send-email-sms
      ref="send-email-sms"
      :form="detailData.customer_profile"
      :skip="false"
      :is-only-referrer="isFina"
      :is-account-referrer="isFina"
      :initContent="detailData.reset_url_data"
      :initReferContent="detailData.reset_url_data"
      @send="handlerSend" />

    <div
      v-if="isDev"
      class="text-block">
      <v-button
        type="danger"
        @click="handlerTest">測試數據</v-button>
    </div>
    <send-email-sms
      ref="send-create-sms"
      :form="formData"
      :type="identity"
      :initContent="smsContent"
      :updateContent="true"
      @send="handlerCreateSend"
      @skip="handlerSkip" />
    <email-dialog
      ref="login-email"
      :emailData="emailData"
      @continue="handleContinue"
    ></email-dialog>
  </section>
</template>

<script>
import AccountForm from './components/form/account-form'
import AddressForm from '@/views/components/address-form'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import {emailDialog} from './components/emailAccount'
import {checkCompanyEmail, createAccount, getAccountDetail, getSmsTemplate, sendPasswordRestList} from '@/api/account'

export default {
  name: 'AccountsCreate',
  components: {
    AccountForm,
    AddressForm,
    SendEmailSms,
    emailDialog
  },
  props: {
    isReferralRequest: {
      type: Boolean,
      default: false
    },
    referralRequestId: {
      type: Number,
      default: 0
    },
    relation: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      customerId: '',
      // createdStatus: false,
      subForm: {
        'base-info': false,
        'address-info': false
      },
      formData: {},
      detailData: {},
      formDataLock: 0, // 表單鎖，防止外層修改數據覆蓋了組件裏的表單數據
      isSend:false,
      identity:1,
      smsContent:'歡迎加入HoldCover！送你 50 Hold Dollars 體驗一站式保險服務！',
      emailData:{},
      existEmail:false
    }
  },
  computed:{
    user_type(){
      let {user_type} = this.$route.query
      return user_type
    },
    isFina(){
      return this.user_type == 2
    }
    // smsContent(){
    //   return 'Welcome to HoldCover! You will receive 50 Hold Dollars to experience the one-stop insurance services!'
    // }
  },
  created() {
    if(this.isReferralRequest) {
      const {
        // name,
        // nick_name,
        phone,
      } = this.relation
      this.formDataLock += 1
      this.formData = {
        phone,
        phone_no: phone
      }
    }
  },
  methods: {
    handleContinue(){
      this.network().createAccount()
    },
    handlerChange(val){
      this.identity  =val
    },
    handlerBack() {
      if(this.isReferralRequest) {
        this.$emit('back')
        return
      }
      this.$router.back()
    },
    handlerTest() {
      this.formDataLock += 1
      this.formData = Object.assign(this.formData, {
        identity: 1,
        phone: '67896789',
        isrd_lst_nm: 'A',
        isrd_fst_nm: 'Peng',
        email: 'example@next.com',
        isrd_sex: 1,
        isrd_dob: '1990-01-01',
        id_type: 1,
        id_no: 'A1234563',
        occ_id: 12,
        isrd_com_nm: 'NIT',
        contact_lst: 'A',
        contact_fst: 'ENGP',
        contact_email: 'example@next.com',
        contact_phone: '67896789',
        bsns_nature_id: 3,
        addr_room: 'AA',
        addr_floor: '15',
        addr_block: 'BB',
        addr_building: 'CC',
        addr_street: 'DD',
        addr_district: 5,
        addr_area: 2,
        addr_region: 1,
      })
      this.formData = JSON.parse(JSON.stringify(this.formData))
    },
    handlerViewAccount() {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.customerId,
        }
      })
    },
    handlerCreateSend(content){
      this.formData.is_send = 1
      this.formData.content = content
      // this.$refs['send-create-sms'].changeDialog()
      this.network().createAccount()
    },
    handlerSkip(){
      this.formData.is_send = 0
      // this.$refs['send-create-sms'].changeDialog()
      this.network().createAccount()
    },
    handlerNext() {
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitForm(key)
      })
      if(Object.values(this.subForm).some(item => item === false)) {
        return
      }
      let {identity,language}  = this.formData
      this.network().getSmsTemplate({language})

      if(identity==1)
      {
        this.network().createAccount()
        // this.$refs['send-create-sms'].changeDialog()
      }
      else
      {
        //校验公司邮箱是否已经注册
        this.network().checkCompanyEmail()
      }

    },
    handlerSMS(){
      this.$refs['send-email-sms'].changeDialog()
    },
    handlerSend(content){
      this.network().sendPasswordRestList(content)
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = JSON.parse(JSON.stringify(Object.assign(this.formData, data)))
    },
    network() {
      return {
        createAccount: async () => {
          let params = this.formData||{}
          if(this.isFina){
            delete params.referrer_code
          }
          const { data } = await createAccount({...params,user_type:this.user_type})
          let {attached_account} =data
          this.existEmail = attached_account||false
          if(this.isReferralRequest) {
            this.network().setReferralRequestUser(data.id)
            return
          }
          this.isSend =false
          this.customerId = data.id
          this.network().getAccountDetail()
        },
        getAccountDetail: async () => {
          const {data} = await getAccountDetail({
            customer_id: this.customerId
          })
          this.detailData = data

        },
        setReferralRequestUser: async (id) => {
          const { data } = await checkCompanyEmail({
            referral_request_id: this.referralRequestId,
            customer_id: id
          })
          this.$emit('success')
        },
        sendPasswordRestList: async (content) => {
          const { data,status } = await sendPasswordRestList({
            customer_id:this.customerId,
            content,
            type: 1
          })
          //data.message/data.message_lang
          if (status == 200)
          {
            this.$message({
              type: 'success',
              message: 'Success'
            })
            this.isSend = true
          }
        },
        checkCompanyEmail: async ()=>{
          let {isrd_com_nm,email} = this.formData||{}
          const { data } = await checkCompanyEmail({company_name:isrd_com_nm,email,user_type:this.user_type})
          let {existed} = data
          this.emailData = data
          if(!existed)
            this.network().createAccount()
          else{
            this.$refs['login-email'].handleShow()
          }
        },

        getSmsTemplate: async (params) => {
          const {data} = await getSmsTemplate(params)
          this.smsContent = data.create_account
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  padding-bottom: 100px;
  color: #303133;
  &.sub {
    padding: 20px;
    .btn-top-container {
      right: 20px;
    }
  }
  .mgb-5 {
    margin-bottom: 5px;
  }
  .btn-top-container {
    position: absolute;
    top: 20px;
    right: 0;
  }
  h1 {
    margin-bottom: 20px;
    font-size: 34px;
  }
  .form-card {
    display: flex;
    width: 912px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .form-left,
    .form-right {
      flex: 1;
    }
    .form-left {
      padding: 20px;
      border-right: 1px solid #dddfe7;
    }
    .form-right {
      padding: 20px;
    }
    .form-block {
      margin-bottom: 15px;
      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        color: #616266;
        font-weight: bold;
        font-size: 14px;
      }
    }
    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }
    .form-flex {
      display: flex;
      justify-content: space-between;
      & > .form-block {
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .done-container {
    padding: 15px 0 15px 15px;
    width: 432px;
    color: #616266;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    h2 {
      font-size: 24px;
    }
    p {
      margin: 15px 0 15px 0;
      font-size: 16px;
    }
  }
  .send-title{
    color: #616266;
    font-family: "Helvetica Neue";
    font-size: 20px;
  }
  .send-tip{
    color: #616266;
    font-family: "Helvetica Neue";
    font-size: 16px;
  }
  .send-title{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
  }
  .exist-eamil{
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
  }
}
</style>
